export const isUnifiedFieldGroupID = (fieldGroupID: string) => {
  return fieldGroupID === '_source_Common';
};
